import { render, staticRenderFns } from "./unified-insights-reports.vue?vue&type=template&id=4081ee8c&"
import script from "./unified-insights-reports.vue?vue&type=script&lang=tsx&"
export * from "./unified-insights-reports.vue?vue&type=script&lang=tsx&"
import style0 from "./unified-insights-reports.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports